<h1 mat-dialog-title>{{title}}</h1>
<mat-dialog-content [formGroup]="projectForm" autocomplete="off">
  @if (message) {
    <div class="billing-note"><mat-icon>info</mat-icon><span>{{message}}</span></div>
  }

  <section class="section">
    <h3>Details</h3>
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input type="text" matInput formControlName="name" placeholder="Unique name for the project" [errorStateMatcher]="matcher" id="project-name" [maxlength]="PROJECT_NAME_MAX" required>
      <mat-hint align="end">{{projectForm.value.name?.length || 0}}/{{PROJECT_NAME_MAX}}</mat-hint>
      @if (projectForm.controls['name'].hasError('required')) {
        <mat-error>Name is <strong>required</strong></mat-error>
      }@else if (projectForm.controls['name'].invalid) {
        <mat-error>Name must be between {{PROJECT_NAME_MIN}} and {{PROJECT_NAME_MAX}} characters</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input type="text" matInput formControlName="description" placeholder="Describe the purpose of the project" [errorStateMatcher]="matcher" id="project-description" [maxlength]="PROJECT_DESCRIPTION_MAX">
      <mat-hint align="end">{{projectForm.value.description?.length || 0}}/{{PROJECT_DESCRIPTION_MAX}}</mat-hint>
    </mat-form-field>
    <div class="dates">
      <mat-form-field>
        <mat-label>Start date</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="startDate" required>
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        @if (projectForm.controls['startDate'].hasError('required')) {
          <mat-error>Start date is <strong>required</strong></mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Target completion</mat-label>
        <input matInput [matDatepicker]="completionPicker" formControlName="completionDate" [min]="projectForm.value.startDate">
        <mat-datepicker-toggle matSuffix [for]="completionPicker"></mat-datepicker-toggle>
        <mat-datepicker #completionPicker></mat-datepicker>
        <mat-hint>Optional</mat-hint>
      </mat-form-field>
    </div>
    @if (projectForm.hasError('completionBeforeStart') && projectForm.controls['completionDate'].touched) {
      <mat-error class="form-error">Target completion must be on or after the start date</mat-error>
    }
    <div class="toggle-row">
      <mat-slide-toggle formControlName="sandbox" color="accent">Sandbox</mat-slide-toggle>
      <span class="toggle-hint">
        A sandbox holds models that are independent of current state and can't be merged into it.
        @if (!data.isNew) { This can only be chosen when the project is created. }
      </span>
    </div>
  </section>

  <section class="section">
    <h3>Access</h3>
    <div class="toggle-row">
      <mat-slide-toggle formControlName="useOrganisationAccess" color="accent">Use organisation access</mat-slide-toggle>
      <span class="toggle-hint">
        @if (projectForm.value.useOrganisationAccess) {
          Users have the same access to this project as they do to the organisation. Turn off to choose access for each user.
        }@else {
          Choose each user's access to this project. Users set to No access can't open it, but can ask for access.
        }
      </span>
    </div>
    @if (!projectForm.value.useOrganisationAccess) {
      <app-user-access [userAccess]="project.userAccess"></app-user-access>
    }
  </section>
</mat-dialog-content>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancelClick()">Cancel</button>
  <button mat-flat-button color="accent" cdkFocusInitial (click)="save()">
    {{data.isNew?'Create project':'Save changes'}}
  </button>
</div>
